import React from "react";
import { Container, Grid, Box, Typography, Card, CardContent } from "@mui/material";
import HttpsIcon from '@mui/icons-material/Https';
import DnsIcon from '@mui/icons-material/Dns';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import DomainIcon from '@mui/icons-material/Domain';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const features = [
  {
    title: 'TLS/SSL Management',
    description: 'End-to-end management of your security certificates. We handle issuance, installation, and renewals before they expire.',
    imageurl: 'https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg',
    icon: <HttpsIcon sx={{ fontSize: 30, color: '#facd00' }} />
  },
  {
    title: 'DNS Record Security',
    description: 'Optimization and security hardening of your DNS records to prevent hijacking and ensure 100% uptime.',
    imageurl: 'https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg',
    icon: <DnsIcon sx={{ fontSize: 30, color: '#facd00' }} />
  },
  {
    title: 'Email Authentication',
    description: 'Implementation of SPF, DKIM, and DMARC protocols to protect your domain reputation and ensure email deliverability.',
    imageurl: 'https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg',
    icon: <MarkEmailReadIcon sx={{ fontSize: 30, color: '#facd00' }} />
  },
  {
    title: 'Domain Portfolio',
    description: 'Centralized management of your corporate domains, ensuring ownership rights are protected and organized.',
    imageurl: 'https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg',
    icon: <DomainIcon sx={{ fontSize: 30, color: '#facd00' }} />
  },
  {
    title: 'Brand Protection',
    description: 'Monitoring for look-alike domains and potential phishing threats targeting your digital brand assets.',
    imageurl: 'https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg',
    icon: <SecurityIcon sx={{ fontSize: 30, color: '#facd00' }} />
  },
  {
    title: 'Identity Verification',
    description: 'Setup and management of digital identity trust seals and verification records for your online presence.',
    imageurl: 'https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg',
    icon: <VerifiedUserIcon sx={{ fontSize: 30, color: '#facd00' }} />
  },

];

const FeaturesPage = () => {
  return (
    <Container maxWidth="lg">
      {/* Hero Section (Fully Contained) */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "300px", sm: "400px", md: "500px" }, // Responsive height
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end", // Align text to the right
          paddingRight: { xs: 2, sm: 5, md: 10 }, // Adjust padding for right-aligned text
          borderRadius: 2,
          overflow: "hidden",
          mt: 1
        }}
      >
        {/* Background Image Layer (Constrained to Container) */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url('https://storage.googleapis.com/app_darkendimg/data-speedway/digi-assets.jpg')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#000",
            filter: "brightness(0.6)", // Darkens for readability
            zIndex: -1
          }}
        />

        {/* Animated Text Box */}
        <Box sx={{ maxWidth: '600px', textAlign: 'right', p: 3, borderRight: '4px solid #facd00' }}>
          <Typography variant="h3" fontWeight="bold" sx={{ color: "white" }}>
            Digital Asset Management
          </Typography>
          <Typography variant="h6" sx={{ color: "#facd00", mt: 1 }}>
            Securing the Infrastructure of Your Brand
          </Typography>
          <Typography variant="body1" sx={{ color: "#fff", mt: 2 }}>
            From SSL certificates to DNS configurations, we manage the critical invisible assets that keep your business online and secure.
          </Typography>
        </Box>

      </Box>

      {/* Features Grid (Contained in Container) */}
      <Box sx={{ textAlign: 'center', mt: 6, mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" >
          Infrastructure Protection Services
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center" mb={6}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ boxShadow: 3, borderRadius: 3, height: '100%' }}>

              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box sx={{ bgcolor: '#000', p: 1, borderRadius: 1, display: 'flex', mr: 2 }}>
                    {feature.icon}
                  </Box>

                  <Typography variant="h6" fontWeight="bold">
                    {feature.title}
                  </Typography>
                </Box>
                <Typography variant="body2" mt={1} color="textSecondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default FeaturesPage;
